export * from "./StatusColorComponent";